import Gb from './Gb';

export default Gb;
